import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import LicensesTable from './components/LicensesTable';
import AddLicenseForm from './components/AddLicenseForm';

import ListGrid from '../../common/components/ListGrid/ListGrid';
import TableWrapper from '../../common/components/TableWrapper/TableWrapper';
import ListActions from '../../common/components/ListActions';
import Title from '../../common/components/Title';
import Modal from '../../common/components/Modal';
import {hetch} from "../../utils/fetch.hooked";

function Licenses({ permission }) {
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [page, setPage] = useState(query.get('pageNumber') ?? 1);
  const [count, setCount] = useState(1);
  const [rows, setRows] = useState(null);

  const handleAddModalClose = () => setAddModalOpen(false);
  const triggerRefetch = () => setRefetch(refetch => !refetch);

  useEffect(() => {
    history.push({
      search: `pageNumber=${page}`
    })
  }, [history, page]);

  useEffect(() => {
    const fetchData = () => {
      setIsFetching(true);
      hetch(`/api/licenses?pageNumber=${page}`)
        .then(res => res.json())
        .then(res => {
          setRows(res?.content ?? []);
          setCount(Math.ceil(res.total/res.pageSize));
        })
        .finally(() => {
          setIsFetching(false);
        });
    }

    fetchData();
  }, [page, refetch]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <ListGrid
        header={(
          <Title
            title="Лицензии КриптоПро"
            actions={(
              <ListActions
                addTitle="Добавить лицензию"
                refreshTitle="Обновить список лицензий"
                onAddClick={() => setAddModalOpen(true)}
                isRefreshing={isFetching}
                onRefreshClick={triggerRefetch}
                permission={permission}
              />
            )}
          />
        )}
        body={(
          <TableWrapper
            rows={rows}
            count={count}
            page={page}
            emptyAlertText="Лицензии не найдены"
            isFetching={isFetching}
            onChange={handleChange}
          >
            <LicensesTable rows={rows} triggerRefetch={triggerRefetch}/>
          </TableWrapper>
        )}
      />
      <Modal
        header="Обновление лицензии КриптоПро"
        open={addModalOpen}
        onClose={handleAddModalClose}
      >
        <AddLicenseForm triggerRefetch={triggerRefetch} handleClose={handleAddModalClose}/>
      </Modal>
    </>
  );
}

export default Licenses;
